<template lang="pug">
v-container(fluid class=" pt-2 pb-0  tw-h-full tw-overflow-hidden")
  div(class=" tw-flex tw-flex-col tw-h-full  tw-overflow-hidden tw-rounded-tr tw-rounded-tl")
    div(class=" tw-flex-col ")
      v-row(class="pt-0 mt-0 tw-bg-indigo-lighten-5  tw-overflow-hidden")
        v-col(class="tw-pl-6")
          v-row(no-gutters)
            v-col
              span(class=" tw-text-left tw-font-semibold text-secondary tw-text-xl ") {{ lead.name }} {{ lead.last_name }}
          v-row(no-gutters class="tw-pt-2 " align="center")
            v-col(cols="auto" class=" tw-mr-3")
              span(v-if="lead.phone" class=" text-caption tw-text-gray-darken-2")
                v-icon(small class="tw-mr-1") mdi-phone-classic
                | {{ lead.phone }}
            v-col(cols="")
              span(v-if="lead.email" class=" text-caption tw-text-gray-darken-2")
                v-icon(small class="tw-mr-1") mdi-email
                | {{ lead.email }}
        v-col(cols="auto" class=" tw-text-right tw-pr-5 ")
          v-row(no-gutters)
            v-col
              span(class="tw-text-indigo-lighten-3 tw-font-bold tw-text-lg  ") Lead \#{{ lead.id }}
          v-row(no-gutters class="tw-pt-1")
            v-col
              span(class="tw-text-gray-darken-2") {{ this.$moment(lead.created_at).fromNow() }}
    div(class=" tw-flex-col tw-flex-1 tw-overflow-y-scroll tw-overflow-x-hidden")
      v-row(no-gutters class="mt-4")
        v-col
          span(class=" h4 tw-font-semibold") Interested in
      v-row(no-gutters)
        v-col
          kubiqa-goods-list-item
      v-row(class="tw-pt-3")
        v-col(v-if="lead.message")
          | {{ lead.message }}
    div(class="tw-flex-col ")
      template(v-if="lead.opportunity")
        v-row
          v-col
            span Opportunity
            v-row(class="tw-py-2")
              v-col
                router-link(
                  class="tw-font-medium text-link tw-capitalize"
                  :to="{ name: 'opportunityDetail', params: { id: lead.opportunity.id } }"
                ) {{ lead.opportunity.name }}
      template(v-else)
        v-row(
          no-gutters
          align="center"
          justify="end"
          class=" tw-mt-6 tw-px-4  tw-bg-indigo-lighten-4 tw-bg-opacity-25 tw-w-full tw-rounded-bl tw-rounded-br"
        )
          v-col(cols="auto")
            v-btn(
              x-small
              text
              elevation="0"
              :ripple="false"
              @click="discard()"
            )
              span(class=" tw-text-xs tw-pt-4 tw-text-gray-darken-1") DISCARD
          v-col(cols="auto")
            v-btn(depressed color="rgba(94,129,244,0.80)" @click="addOpportunityDialogToggle()")
              span(class="tw-font-bold") CREATE OPPORTUNITY
  v-dialog(v-model="addOpportunityDialog" width="75%" max-width="75%")
    div(class="tw-bg-white add-listing-modal")
      kubiqa-opportunities-add(:key="mKey" @close="addOpportunityDialogToggle")
</template>
<script>
export default {
  data() {
    return {
      addOpportunityDialog: false,
      mKey: 1,
      loading: false,
    };
  },
  computed: {
    lead() {
      return this.$store.getters['leads/current_lead'];
    },
  },
  watch: {
    leadId: function (oldValue, newValue) {
      if (oldValue !== newValue || !oldValue) {
        return this.fake();
      }
    },
  },

  methods: {
    addOpportunityDialogToggle() {
      this.mKey = ++this.mKey;
      return (this.addOpportunityDialog = !this.addOpportunityDialog);
    },
    discard() {
      console.log('discard');
      this.loading = true;
      this.lead.status = 'discarded';
      this.$store.dispatch('leads/update', this.lead);
    },
  },
};
</script>
